export const SOUND_FILES = {
  click: "ui-click", select: "ui-select", pickup: "cargo-received",
  warning: "hull-warning", ability: "module-activate", repair: "repair",
  pulse: "pulse", laser: "laser", missile: "missile", flak: "flak",
  rail: "rail", ion: "ion", mine: "mine", shield: "shield-hit",
  hull: "hull-hit", explosion: "explosion", launch: "launch",
  dock: "dock", jump: "jump", engine: "engine",
} as const;

export type SoundId = keyof typeof SOUND_FILES;
export type MusicScene = "station" | "exploration" | "danger" | "combat";
export const MUSIC_FILES: Record<MusicScene, string> = {
  station: "safe-harbor", exploration: "last-signal", danger: "ghosts-of-the-rift", combat: "contact",
};
export interface SoundCue {
  id: SoundId;
  gain: number;
  pan: number;
}

export function weaponSound(kind: string): SoundId {
  switch (kind) {
    case "laser": case "missile": case "flak": case "rail": case "ion": case "mine":
      return kind;
    default: return "pulse";
  }
}
